import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardHeader,
  Heading,
  Flex,
  Button,
  VStack,
  CardBody,
  Image,
  Divider,
  Modal,
  ModalOverlay,
  ModalContent,
  Link,
} from '@chakra-ui/react';
import { IoMdAddCircle } from 'react-icons/io';
import { useMediaQuery } from '@chakra-ui/react';
import axios from 'axios';

import OrdersCard from './OrdersCard';

function Authentication() {
  const [cardData, setCardData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOrders = async () => {
      axios.defaults.baseURL = "https://glb-api.onrender.com";
      await axios
        .get('/sop/orders', {
         withCredentials : true
        })
        .then(
          (res) => {
            console.log(res);
            setCardData(res.data.orders);
          }
        )
        .catch(
          (error) => {
            console.log(error);
            setError(error.response.data.message);
          }
        );
    };
    fetchOrders();
  }, []);

  return (
    <>
      <div>
        {cardData && cardData.length > 0 ? (
          <Box width={'100%'} p={4}>
            <Card variant={'elevated'} minH={'100vh'}>
              <CardHeader bg="gray.100">
                <Flex alignItems="center" justifyContent="space-between">
                  <Heading as="h1" size="2xl">
                    Your Orders
                  </Heading>
                  <Link to="/RsopForm">
                    <Button
                      leftIcon={<IoMdAddCircle />}
                      colorScheme="blue"
                      variant="solid"
                      size={'lg'}
                      display={{ base: 'none', md: 'inline-flex' }}
                      fontSize={'xl'}
                      href={'#'}
                    >
                      New Order
                    </Button>
                  </Link>
                </Flex>
              </CardHeader>
              <CardBody>
                <VStack>
                  {cardData.map((card) => (
                    <OrdersCard
                      key={card._id}
                      title={`Order ${card.orderId}`}
                      id={card.orderId}
                      status={card.workStatus}
                      qnaStatus={card.qnaStatus}
                    />
                  ))}
                </VStack>
              </CardBody>
            </Card>
          </Box>
        ) : (
          <Box width={'100%'} pt={10} alignContent="center">
            <Image
              src="https://cdn-icons-png.flaticon.com/512/241/241555.png?w=740&t=st=1691836026~exp=1691836626~hmac=bf8fbe77bfcab617d8c69925839c49a8720f1f6cea2adeee2c857ac9375e2cbf"
              alt="No Orders"
              maxW="200px"
              mx="auto"
            />
            <Heading size="xl" textAlign="center" color="grey.500">
              You haven't placed any order yet!
              <hr />
              {error}
            </Heading>
          </Box>
        )}
      </div>
    </>
  );
}

export default Authentication;
